import React from 'react';
import { IconProps } from '../../icons/types';

const LockedErrorIcon: React.FC<IconProps> = ({ className }) => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="32" cy="32" r="30.5" stroke="#F1AA23" strokeWidth="3" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32 22.3333C29.6068 22.3333 27.6667 24.2734 27.6667 26.6667L27.6667 32L25.6667 32L25.6667 26.6667C25.6667 23.1689 28.5022 20.3333 32 20.3333C35.4978 20.3333 38.3333 23.1689 38.3333 26.6667L38.3333 32L36.3333 32L36.3333 26.6667C36.3333 24.2734 34.3932 22.3333 32 22.3333Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.3333 32.8485C21.3333 30.1707 23.7212 28 26.6667 28L37.3333 28C40.2789 28 42.6667 30.1707 42.6667 32.8485L42.6667 39.1515C42.6667 41.8293 40.2789 44 37.3333 44L26.6667 44C23.7212 44 21.3333 41.8293 21.3333 39.1515L21.3333 32.8485ZM33.3299 38.1777C33.3437 38.2917 33.3034 38.4061 33.2192 38.4917C33.135 38.5773 33.0143 38.6263 32.888 38.6263L31.1102 38.6263C30.9839 38.6263 30.8633 38.5773 30.7791 38.4917C30.6949 38.4061 30.6545 38.2917 30.6684 38.1777L30.9488 35.8856C30.4935 35.5845 30.2214 35.1083 30.2214 34.5859C30.2214 33.6945 31.0186 32.9697 31.9991 32.9697C32.9796 32.9697 33.7769 33.6945 33.7769 34.5859C33.7769 35.1083 33.5048 35.5845 33.0495 35.8856L33.3299 38.1777Z"
        fill="white"
      />
    </svg>
  );
};

export default LockedErrorIcon;
